import { useState, useCallback, useRef, useEffect } from 'react';
import { Tabs, TabList, Tab } from 'react-aria-components';
import { MapCz } from '@pages/sales-network/maps/MapCz';
import { MapSk } from '@pages/sales-network/maps/MapSk';
import TabPanel from '@pages/sales-network/shared/TabPanel';
import { CountryEnum } from '@api/types/CountryEnum';



const SalesNetwork = (): JSX.Element => {

	const footerRef = useRef<HTMLDivElement | null>(null);
	const [ selectedRegion, setSelectedRegion ] = useState<string>('');


	useEffect(() => {
		if (selectedRegion !== '') {
			setTimeout(() => footerRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 150);
		}
	}, [ selectedRegion, footerRef ]);

	
	const handleRegionClick = useCallback((regionId: string) => {
		regionId === selectedRegion ? setSelectedRegion('') : setSelectedRegion(regionId);
	},[ selectedRegion ]);

	
	return (
		<div className="app-page sales-network-page">
			
			<h1>Partnerské veteriny</h1>

			<Tabs>
				<TabList aria-label="Sales network countries">
					<Tab id={CountryEnum.cz}>Česká republika</Tab>
					<Tab id={CountryEnum.sk}>Slovenská republika</Tab>
				</TabList>
			
				<TabPanel country={CountryEnum.cz} selectedRegion={selectedRegion}>
					<MapCz
						selectedRegion={selectedRegion}
						onRegionClick={handleRegionClick} />
				</TabPanel>

				<TabPanel country={CountryEnum.sk} selectedRegion={selectedRegion}>
					<MapSk
						selectedRegion={selectedRegion}
						onRegionClick={handleRegionClick} />
				</TabPanel>
			</Tabs>

		</div>
	);
};

export default SalesNetwork;